import styled from "styled-components";

export const FormContainer = styled.div`
  margin: 50px 0;
  
  h2 {
		font-size: 32px;
		margin-bottom: 16px;
  }
  
  h3 {
    margin-bottom: 15px;
  }
  
  .form-input {
		display: flex;
		flex-direction: column;
		row-gap: 10px;
    margin-bottom: 10px;
  }
  
  .form-group {
		margin-bottom: 25px;
    
    label {
      display: inline-block;
      margin-bottom: 7px;
    }
  }
	
	input {
		border: 1px solid #ccc;
    padding: 10px;
    transition: .3s;
    
    &:focus {
			border-color: #e49b00;
    }
    
    &[type='checkbox'],
    &[type='radio'] {
      padding: 5px;
    }
	}
  
  textarea {
    width: 100%;
		border: 1px solid #ccc;
		padding: 10px;
		transition: .3s;
		
		&:focus {
			border-color: #e49b00;
		}
  }
  
  
  button {
    margin-top: 20px;
		border: 1px solid #e49b00;
		padding: 10px 25px;
		background-color: #e49b00;
		color: #fff;
		font-size: 18px;
		line-height: normal;
    transition: .3s;
    
    &:hover {
      background-color: #fff;
      cursor: pointer;
      color: #e49b00;
    }
    
  }
`

export const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
  appearance: none; /* Remove native checkbox */
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
  transition: all 0.2s ease;
  margin-right: 10px;

  &:checked {
    background-color: #e49b00; /* your custom color */
    border-color: #e49b00;
  }

  &:hover {
    border-color: #b67a00;
  }

  &:focus {
    outline: 2px solid #e49b00;
    outline-offset: 2px;
  }
`;

export const StyledRadio = styled.input.attrs({ type: "radio" })`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  background-color: white;
  transition: all 0.2s ease;
  margin-right: 10px;
  position: relative; /* Wichtig für ::after */

  &:checked {
    border-color: #e49b00;
    
    /* Innerer Kreis statt voller Hintergrund */
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #e49b00;
    }
  }

  &:hover {
    border-color: #b67a00;
  }

  &:focus {
    outline: 2px solid #e49b00;
    outline-offset: 2px;
  }
`;